import { AvatarColors } from "../enums/base.enums";

export class RandomUtilities {

    public static getRandomValue(collection: any): any {
        const collectionObject = Object.values(collection);
        const randomIndex = Math.floor(Math.random() * collectionObject.length);
        return collectionObject[randomIndex];
    }

    public static getRandomAvatarColor() : AvatarColors {
        return RandomUtilities.getRandomValue(AvatarColors);
    }
}